import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Form, Button } from 'react-bootstrap5';

export default function Topic({ topic, updateTopicStatus }) {
  const [checked, setChecked] = useState(topic.checked);
  const [fullText, setShowFullText] = useState(false);

  const updateStatus = (status) => {
    setChecked(status);
    updateTopicStatus(topic, status);
  };

  return (
    <div>
      <label htmlFor={`topic-${topic.id}`} className={`topic h-100 ${checked ? 'checked' : ''}`}>
        <div className="icon-with-text mb-1">
          <i
            style={{
              WebkitMaskImage: `url(${topic.attributes.icon})`,
              maskImage: `url(${topic.attributes.icon})`,
            }}
          />

          <span className={`text-content me-2 ${!fullText && 'text-truncate'}`}>
            {topic.attributes.title}
          </span>

          <Form.Check
            inline
            id={`topic-${topic.id}`}
            bsPrefix=" "
            className="text-content ms-auto"
          >
            <Form.Check.Label>
              <Form.Check.Input
                checked={checked}
                onChange={() => updateStatus(!checked)}
              />
            </Form.Check.Label>
          </Form.Check>
        </div>

        <p className={!fullText && 'text-truncate'}>{topic.attributes.description}</p>

        <Button
          variant="link"
          onClick={() => setShowFullText(!fullText)}
          className="p-0"
        >
          {fullText ? 'Hide full description' : 'View full description' }
        </Button>
      </label>
    </div>
  );
}

Topic.propTypes = {
  topic: PropTypes.object.isRequired,
  updateTopicStatus: PropTypes.func.isRequired,
};
